import {ChevronDownIcon, ChevronUpIcon} from "@chakra-ui/icons";
import {
  Table as ChakraTable,
  TableContainer,
  Td,
  Tbody,
  Th,
  Thead,
  Tr,
  Spinner,
} from "@chakra-ui/react"
import { useTranslation } from "react-i18next";
import { FaRegFolderOpen } from "react-icons/fa";

export interface TableColumn {
  Header: string;
  accessor: string;
  isSortable?: boolean;
}

export interface SortParams {
  sortBy: string;
  isSortedDesc: boolean;
}

export interface TableProps {
  data: any[];
  columns: TableColumn[];
  onRowClick: (data: any) => void;
  sortParams?: SortParams | null;
  setSortParams?: (x: SortParams) => void;
  Pagination?: JSX.Element;
  loading?: boolean;
}

const Table = (props: TableProps) => {
  const { t } = useTranslation("translations");

  return (
    <TableContainer className="max-w-[100vw]">
      <ChakraTable className="relative h-fit max-w-[100vw]">
        {
          props.loading &&
            <div
              className="w-full h-full absolute bg-gray-500/20 flex justify-center items-center top-0 left-0"
            >
              <Spinner
                thickness='4px'
                speed='0.65s'
                emptyColor='gray.200'
                color='blue.500'
                size='xl'
              />
            </div>
        }
        <Thead>
          <Tr>
            {props.columns.map((col, i) =>
              <Th
                key={`table_head_column_${i}`}
                className={col.isSortable ? "hover:bg-green-300/30 my-auto" : "my-auto"}
                onClick={() => {
                  if (!props.setSortParams || !col.isSortable) return;
                  if (props.sortParams && props.sortParams.sortBy === col.accessor.charAt(0).toUpperCase() + col.accessor.slice(1)) {
                    props.setSortParams({
                      ...props.sortParams,
                      isSortedDesc: !props.sortParams.isSortedDesc
                    })
                  } else {
                    props.setSortParams({
                      sortBy: col.accessor.charAt(0).toUpperCase() + col.accessor.slice(1),
                      isSortedDesc: false,
                    });
                  }
                }}
              >
                {col.Header}
                {
                  props.sortParams &&
                  props.sortParams.sortBy === col.accessor.charAt(0).toUpperCase() + col.accessor.slice(1)
                  && col.isSortable ? (
                    props.sortParams.isSortedDesc ? (
                      <ChevronDownIcon ml={2} w={4} h={4}/>
                    ) : (
                      <ChevronUpIcon ml={2} w={4} h={4}/>
                    )
                  ) : (
                    ""
                  )
                }
              </Th>
            )}
          </Tr>
        </Thead>
        <Tbody>
          {
            props.data.map((d, indexRow) => (
              <Tr key={`table_row_${indexRow}`} onClick={() => props.onRowClick(d)}
                  className="hover:bg-teal-500">
                {props.columns.map((c, indexCell) =>
                  <Td key={`table_cell_${indexRow}_${indexCell}`}>
                    {d[c.accessor]}
                  </Td>
                )}
              </Tr>
            ))
          }
        </Tbody>

      </ChakraTable>

      {
       !props.loading && props.data.length === 0 &&
        <div className="w-full flex flex-col justify-center items-center opacity-80">
          <FaRegFolderOpen className="w-[300px] h-[250px] opacity-60" />
          <div className="text-[32px]">
              {t("NO_DATA_IN_TABLE")}
          </div>
        </div>
      }
      {props.Pagination}

    </TableContainer>
  )
}

export default Table;
